import { Route, Routes } from 'react-router-dom';

import { CreatePenalty } from './views/CreatePenalty';
import { EditPenalty } from './views/EditPenalty';
import { ListPenalties } from './views/ListPenalties';

export const PenaltiesRouting = () => {
  return (
    <Routes>
      <Route path="" element={<ListPenalties />} />
      <Route path="create" element={<CreatePenalty />} />
      <Route path=":id" element={<EditPenalty />} />
    </Routes>
  );
};
